import { useMutation } from '@apollo/client';
import { PATCH_CURRICULUM_MUTATION } from '../../mutations';

export function usePatchCurriculumMutation() {
    return useMutation( PATCH_CURRICULUM_MUTATION );
}
